import utility from 'utility';
export default {
  // 设置sessionStorage
  setSessionStorage(name, value) {
    const dataType = typeof name;
    if (['object', 'string', 'boolean', 'number'].indexOf(dataType) > -1) {
      window.sessionStorage.setItem(name, JSON.stringify(value));
    } else {
      alert('该类型不能用于本地存储');
    }
  },
  // 取出sessionStorage
  getSessionStorage(name) {
    const value = window.sessionStorage.getItem(name);
    if (value) {
      return JSON.parse(value);
    } else {
      return '';
    }
  },
  // 移除sessionStorage
  deleteSessionStorage(name) {
    const value = window.sessionStorage.getItem(name);
    if (value) {
      window.sessionStorage.removeItem(name);
    }
  },
  // 密码加盐
  pwdMd5(pwd) {
    // 盐值禁止修改
    return utility.md5(pwd + 'qweRTYUG123@').toUpperCase();
  }
};

// 格式化时间的方法
Date.prototype.format = function (format) { // eslint-disable-line
  const args = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds()
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
    for (const i in args) {
      const n = args[i];
      if (new RegExp('(' + i + ')').test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? n : ('00' + n).substr(('' + n).length)
        );
      }
    }
  }
  return format;
};
